import { render, staticRenderFns } from "./load.vue?vue&type=template&id=7b3bb39c&scoped=true&"
import script from "./load.vue?vue&type=script&lang=js&"
export * from "./load.vue?vue&type=script&lang=js&"
import style0 from "./load.vue?vue&type=style&index=0&id=7b3bb39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3bb39c",
  null
  
)

export default component.exports